import React from "react";
import { gql } from "@apollo/client";

type FormattedCurrencySITextProps = {
	value?: number | null;
	currency?: { abbreviation: string };
};

function FormattedCurrencySIText({
	value,
	currency,
}: FormattedCurrencySITextProps) {
	const formatter = React.useMemo(
		() =>
			Intl.NumberFormat(undefined, {
				style: "currency",
				currency: currency?.abbreviation,
				currencyDisplay: "narrowSymbol",
				notation: "compact",
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			}),
		[currency?.abbreviation],
	);

	if (!value || !currency) {
		return "-";
	}

	return <>{formatter.format(value)}</>;
}

FormattedCurrencySIText.fragment = gql`
	fragment FormattedCurrencySIText on Money {
		value
		currency {
			id
			abbreviation
		}
	}
`;

export default FormattedCurrencySIText;
